import ScheduleItem from 'components/coaches-builder/ScheduleItem/ScheduleItem';

export default ScheduleItem;
